'use client';

import { c as _c } from "react/compiler-runtime";
import { setBottomSheetIsOpen } from '@lib/store/slices/VisualFlatSlice';
import { activeQueueSelector, handleChangeActiveQueue } from '@lib/store/slices/VisualSlice';
import ScrollHelperBlackVisual from '@lib/tools/helpers/ScrollHelperBlackVisual';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import VisualRoot from 'src/app/visual/components/visual-root/VisualRoot';
import VisualRootMobile from 'src/app/visual/components/visual-root/VisualRootMobile';
const VisualPageClient = t0 => {
  const $ = _c(17);
  const {
    data,
    firstQueue,
    secondQueue,
    device
  } = t0;
  const dispatch = useDispatch();
  const activeQueue = useSelector(activeQueueSelector);
  const {
    isDesktop,
    isMobile
  } = device;
  let t1;
  if ($[0] !== data) {
    t1 = queue => {
      if (queue === 1) {
        return 9335;
      }
      if (queue === 2) {
        const secondQueueBulk = data.bulks?.find(_temp);
        return secondQueueBulk.id;
      }
      return null;
    };
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getActiveQueue = t1;
  let t2;
  if ($[2] !== dispatch || $[3] !== isMobile) {
    t2 = () => {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "auto";
        if (isMobile) {
          dispatch(setBottomSheetIsOpen(false));
        }
        dispatch(handleChangeActiveQueue(null));
      };
    };
    $[2] = dispatch;
    $[3] = isMobile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== activeQueue || $[7] !== data || $[8] !== device || $[9] !== firstQueue || $[10] !== getActiveQueue || $[11] !== isDesktop || $[12] !== secondQueue) {
    t4 = isDesktop ? <VisualRoot visual={data} firstQueue={firstQueue} secondQueue={secondQueue} activeQueue={activeQueue} device={device} /> : <VisualRootMobile visual={data} firstQueue={firstQueue} secondQueue={secondQueue} getActiveQueue={() => getActiveQueue(activeQueue)} activeQueue={activeQueue} isMobile={true} />;
    $[6] = activeQueue;
    $[7] = data;
    $[8] = device;
    $[9] = firstQueue;
    $[10] = getActiveQueue;
    $[11] = isDesktop;
    $[12] = secondQueue;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ScrollHelperBlackVisual />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4) {
    t6 = <>{t4}{t5}</>;
    $[15] = t4;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default VisualPageClient;
function _temp(bulk) {
  return bulk.buildingPhase === 2;
}